import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

// Thunk para buscar um usuário pelo ID
export const fetchUserAuthById = createAsyncThunk("userAuth/fetchUserAuthById", async (id) => {
    const response = await fetch(`${API_URL}/user/user/${id}`);
    if (!response.ok) throw new Error("Erro ao buscar usuários");
    return response.json();
});


